import { GetOrderListResponse } from '../../../commons/kymw02/api-services/get-order-list.service';
import { KYMW1203OutputModel } from './vo/kymw1203-output.model';

/**
 * 一括設定画面の値を管理するクラス
 *
 * @export KYMW1203Model
 * @class KYMW1203Model
 */
export class KYMW1203Model {
  mediumType = '';
  pcode = '';
  pricePattern = '';
  settingSpan = '';
  orderCodeFrom = '';
  orderCodeTo = '';

  endOrder = '';
  endCatalog = '';

  out: KYMW1203OutputModel;
  orderCodeList: GetOrderListResponse = [];

  /** 条件フィルタ受注コード */
  get filteredOrderCodeList() {
    return this.orderCodeList.filter(
      _ => this.orderCodeFrom <= _.OrderCode && this.orderCodeTo >= _.OrderCode
    );
  }
}
